/** sessionStorage：列表页跳转订单详情全屏页时携带的 OrderCardDTO */
export const HM_CARE_ORDER_DETAIL_KEY = 'hmCareOrderDetailFocus'

/** sessionStorage：Technicians / Subscriptions 列表跳转 HM Care Orders 时预填筛选 */
export const HM_CARE_ORDERS_LIST_PREFILL_KEY = 'hmCareOrdersListPrefill'

export interface HmCareOrdersListPrefill {
  technicianId?: string
  technicianName?: string
  inspectorId?: string
  inspectorName?: string
  /** 搜索字段，如 subscription_id / order_id */
  searchField?: string
  searchQuery?: string
  /** 进入列表时强制侧栏子项，如 hm_orders（order_id 外链必须在主列表搜） */
  careSubKey?: string
}

function pickPrefillString(v: unknown): string | undefined {
  return typeof v === 'string' && v.trim() ? v.trim() : undefined
}

function parseHmCareOrdersListPrefill(raw: string): HmCareOrdersListPrefill | null {
  const parsed = JSON.parse(raw) as unknown
  if (!parsed || typeof parsed !== 'object') return null
  const o = parsed as HmCareOrdersListPrefill
  const technicianId = pickPrefillString(o.technicianId)
  const technicianName = pickPrefillString(o.technicianName)
  const inspectorId = pickPrefillString(o.inspectorId)
  const inspectorName = pickPrefillString(o.inspectorName)
  const searchField = pickPrefillString(o.searchField)
  const searchQuery = pickPrefillString(o.searchQuery)
  const careSubKey = pickPrefillString(o.careSubKey)
  if (!technicianId && !inspectorId && !(searchField && searchQuery) && !careSubKey) return null
  return {
    technicianId,
    technicianName,
    inspectorId,
    inspectorName,
    searchField,
    searchQuery,
    careSubKey,
  }
}

export function writeHmCareOrdersListPrefill(payload: HmCareOrdersListPrefill): void {
  sessionStorage.setItem(HM_CARE_ORDERS_LIST_PREFILL_KEY, JSON.stringify(payload))
}

/** 只读预填，不删除（供侧栏同步 peek） */
export function peekHmCareOrdersListPrefill(): HmCareOrdersListPrefill | null {
  try {
    const raw = sessionStorage.getItem(HM_CARE_ORDERS_LIST_PREFILL_KEY)
    if (!raw) return null
    return parseHmCareOrdersListPrefill(raw)
  } catch {
    return null
  }
}

export function readHmCareOrdersListPrefill(): HmCareOrdersListPrefill | null {
  try {
    const raw = sessionStorage.getItem(HM_CARE_ORDERS_LIST_PREFILL_KEY)
    if (!raw) return null
    sessionStorage.removeItem(HM_CARE_ORDERS_LIST_PREFILL_KEY)
    return parseHmCareOrdersListPrefill(raw)
  } catch {
    return null
  }
}
